import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import { displayNotif } from 'hb-react/shared/helpers/notifications';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const useOnPayLater = () => {
  const { getFormData } = useRegistrationFlowContext();
  const { event } = useEventContext();

  const postPayLater = async ({ formData, onSuccess }) => {
    try {
      const data = getFormData(formData);

      await axios.post(
        Routes.pay_later_network_event_attendees_path(event.id, {
          format: 'json',
        }),
        data,
      );
      onSuccess();
    } catch (error) {
      displayNotif(
        'error',
        error?.response?.data?.errors ||
          I18n.t('web.networks.events.bookings.booking_error'),
      );
    }
  };

  return { postPayLater };
};
